<div class="ticket-info horarios-info">
  <div class="inputControl TicketsPasos">
    <a
      title="Previo"
      (click)="previoProcedencia()"
      class="prev"
      *ngIf="aplicar == 1"
    >
      <img class="svg" src="assets/img/active-arrow.svg" alt="icono prev" />
    </a>
    <span class="titulo">{{ 'PROCEDENCIA' | translateV2 }}</span>
    <span class="resumen" *ngIf="aplicar == 1">{{ nombreEntradaActual }}</span>
    <a
      title="Próximo"
      (click)="nextProcedencia()"
      class="next"
      *ngIf="aplicar == 1"
    >
      <img class="svg" src="assets/img/active-arrow.svg" alt="icono next" />
    </a>
  </div>
</div>

<div class="onoffswitch-wrapGeneral enProcedencia">
  <div class="onoffswitch-wrap checked">
    <div class="onoffswitch">
      <input
        type="checkbox"
        name="onoffswitch02"
        id="myonoffswitch02"
        class="onoffswitch-checkbox"
        [checked]="aplicar == 0"
        (change)="changeAplicarA()"
      />
      <label class="onoffswitch-label" for="myonoffswitch02"></label>
    </div>
    <label class="onoffswitch-label-text" for="myonoffswitch02">{{
      'APLICAR_VENTA' | translate
    }}</label>
  </div>
  <div *ngIf="!permitirPorEntrada()" class="onoffswitch-wrap checked">
    <div class="onoffswitch">
      <input
        type="checkbox"
        name="onoffswitch03"
        id="myonoffswitch03"
        class="onoffswitch-checkbox"
        [checked]="aplicar == 1"
        (change)="changeAplicarA()"
      />
      <label class="onoffswitch-label" for="myonoffswitch03"></label>
    </div>
    <label class="onoffswitch-label-text" for="myonoffswitch03">{{
      'APLICAR_ENTRADA' | translate
    }}</label>
  </div>
</div>

<div class="procedenciasWrap">
  <!-- <div class="procedencias">
      <div *ngFor="let pais of paises | slice:0:5;let indiceC=index">
        <div class="Rtable-cell procedencia-cell" [class.select]="isPaisSelected(pais, 1)">
          <div class="Rtable-cell--content procedencia-content"
          (click)="seleccionarPais(pais, 1)">
          {{pais.NombrePais}}
        </div>
        </div>
      </div>
      <div class="Rtable-cell procedencia-cell" [class.select]="isPaisSelected(paisSelect.value, 0)">
        <div class="Rtable-cell--content procedencia-content" style="overflow: hidden;">
          <select #paisSelect (change)='seleccionarPais(paisSelect.value, 2)' style="border: none;">
            <option [ngValue]="item" *ngFor="let item of paises | slice:5">{{item.NombrePais}}</option>
          </select>
        </div>
      </div>
    </div> -->

    <div class="procedencias">
      <div *ngIf="paisSeleccionado && (abrirBuscarPais || paisSeleccionadoEnBusqueda)">
        <div
          class="Rtable-cell procedencia-cell"
          [class.select]="true"
          (click)="seleccionarPais(paisSeleccionado, 1)"
        >
          <div class="Rtable-cell--content procedencia-content">
            {{ paisSeleccionado.NombrePais }}
          </div>
        </div>
      </div>
    
      <div *ngFor="let pais of paisesPrimeraFila(); let indiceC = index">
        <div
          class="Rtable-cell procedencia-cell"
          [class.select]="isPaisSelected(pais, 1)"
          (click)="seleccionarPais(pais, 1)"
        >
          <div class="Rtable-cell--content procedencia-content">
            {{ pais.NombrePais }}
          </div>
        </div>
      </div>
    
      <div
        class="Rtable-cell procedencia-cell"
        (click)="abrirBusqueda()"
      >
        <div class="Rtable-cell--content procedencia-content iconoBusqueda">
          <div class="Rtable-cell--content procedencia-content">
            {{ 'BUSCAR_PAIS' | translate }}
          </div>
        </div>
      </div>
    
      <div *ngIf="abrirBuscarPais" [formGroup]="busquedaPaisForm" class="procedencias">
        <div class="separador"></div>
        <div class="form-group textarea">
          <div class="tit-form-group">{{ 'BUSCAR_PAIS' | translate }}</div>
          <input
            #inputBusqueda
            type="text"
            class="form-control"
            formControlName="busquedaPais"
            id="busquedaPais"
            maxlength="40"
            [(ngModel)]="valBusquedaPais"
          />
        </div>
    
        <div class="separador"></div>
    
        <div *ngFor="let pais of paisesSegundaFila(); let indiceC = index">
          <div
            class="Rtable-cell procedencia-cell"
            [class.select]="isPaisSelected(pais, 1)"
            (click)="seleccionarPais(pais, 2)"
          >
            <div class="Rtable-cell--content procedencia-content">
              {{ pais.NombrePais }}
            </div>
          </div>
        </div>
      </div>
    
      <div class="separador"></div>
    
      <div class="procedencias" *ngIf="pasoProcedenciaComunidad">
        <div *ngFor="let comunidad of comunidadesFiltradas; let indiceC = index">
          <div
            class="Rtable-cell procedencia-cell"
            [class.select]="isComunidadSelected(comunidad)"
            (click)="seleccionarComunidad(comunidad, 1)"
          >
            <div class="Rtable-cell--content procedencia-content">
              {{ comunidad.NombreComunidad }}
            </div>
          </div>
        </div>
      </div>
    
      <div class="procedencias" *ngIf="pasoProcedenciaCiudad">
        <div *ngFor="let ciudad of ciudadesFiltradas; let indiceC = index">
          <div
            class="Rtable-cell procedencia-cell"
            [class.select]="isCiudadSelected(ciudad)"
            (click)="seleccionarCiudad(ciudad, 1)"
          >
            <div class="Rtable-cell--content procedencia-content">
              {{ ciudad.NombreCiudad }}
            </div>
          </div>
        </div>
      </div>
    
      <div class="separador"></div>
    
      <div class="procedencias" *ngIf="pasoProcedenciaCPOS" [formGroup]="procedenciaCPOSForm">
        <div class="form-group textarea">
          <div class="tit-form-group">{{ 'CODIGO_POSTAL' | translate }}</div>
          <input
            type="text"
            class="form-control"
            formControlName="procedenciaCPOS"
            id="ProcedenciaCPOS"
            maxlength="40"
            [(ngModel)]="valProcedenciaCPOS"
            (blur)="onBlurCPOS($event)"
          />
        </div>
      </div>
    </div>
    

  <!-- <ul class="pagination">
    <li>
      <a href="#" title="Previo">
        <img class="svg" src="assets/img/active-arrow.svg" alt="icono prev">
      </a>
    </li>
    <li><a href="#">1</a></li>
    <li><a href="#">2</a></li>
    <li><a href="#">3</a></li>
    <li><a href="#">4</a></li>
    <li><a class="active" href="#">5</a></li>
    <li><a href="#">6</a></li>
    <li>
      <a href="#" title="Próximo">
        <img class="svg" src="assets/img/active-arrow.svg" alt="icono next">
      </a>
    </li>
  </ul> -->
</div>
